import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBusAssignmentSchedule } from '../../../../actions/bus/BusAssignmentSchedule';

const BusAssignmentScheduleDeleteButton = ({
  dispatchDeleteBusAssignmentSchedule,
  busAssignmentScheduleId,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () =>
    dispatchDeleteBusAssignmentSchedule({ busAssignmentScheduleId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <button
        type="button"
        className="btn btn-danger"
        disabled={false}
        onClick={openModal}
      >
        <i className="fa fa-trash-o" /> Eliminar
      </button>
    </>
  );
};

BusAssignmentScheduleDeleteButton.propTypes = {
  dispatchDeleteBusAssignmentSchedule: PropTypes.func.isRequired,
  busAssignmentScheduleId: PropTypes.number.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteBusAssignmentSchedule: deleteBusAssignmentSchedule,
};

export default connect(
  null,
  mapDispatchToProps,
)(BusAssignmentScheduleDeleteButton);
